module.exports = __webpack_public_path__ + "img/ic_exportrecord_16.ab47ac2c.svg";